import React, { useState } from 'react'
import { UserW2I9Form } from 'api/everify'
import { Card, Heading, Flex, Box, Icon } from '@workwhile/ui'
import styled from 'styled-components'
import { UserProfile } from 'api/user'
import { ProcessForm } from './ProcessForm'
import { FileTextIcon, ChevronDownIcon, ChevronRightIcon } from 'lucide-react'

export function I9Form({
  user,
  data,
  showProcessForm,
}: {
  user: UserProfile
  data: UserW2I9Form
  showProcessForm?: boolean
}) {
  const [expandedDocs, setExpandedDocs] = useState<Record<string, boolean>>({})
  const [showI9Form, setShowI9Form] = useState(false)

  const toggleDoc = (docUrl: string) => {
    setExpandedDocs((prev) => ({
      ...prev,
      [docUrl]: !prev[docUrl],
    }))
  }

  return (
    !!data && (
      <Card>
        <Heading level={3}>I-9 Form</Heading>
        <Flex>
          <Label>First Name:</Label> {data.firstName}
        </Flex>
        <Flex>
          <Label>Last Name:</Label> {data.lastName}
        </Flex>
        <Flex>
          <Label>Middle Name:</Label> {data.middleName}
        </Flex>
        <Flex>
          <Label>Date of Birth:</Label> {data.dob}
        </Flex>
        <Flex>
          <Label>SSN:</Label> {data.ssn}
        </Flex>
        <Flex>
          <Label>Email Address:</Label> {user.email}
        </Flex>
        <Flex>
          <Label>Phone Number:</Label> {user.phoneNumber}
        </Flex>
        <Flex>
          <Label>Citizenship:</Label> {data.citizenshipStatus}
        </Flex>
        {data.citizenshipStatus === 'permanent-resident' && (
          <Flex>
            <Label>USCIS or A-Number:</Label> {data.uscis}
          </Flex>
        )}
        <Flex>
          <Label>Start Date:</Label> {data.startDate}
        </Flex>
        <Flex>
          <Label>W2 Status:</Label> {user.w2Status}
        </Flex>
        <Flex>
          <Label>Document List:</Label>{' '}
          {data.documentListType === 'list_a' ||
          data.documents.some((doc) => doc.documentName === 'List A')
            ? 'Both Identify/Employment Auth'
            : data.documentListType === 'list_b' ||
                data.documents.some((doc) => doc.documentName === 'List B')
              ? 'Separate Identity/Employment Auth Documents'
              : 'See below'}
        </Flex>
        <Box my={3}>
          {(() => {
            // Find the I-9 Form document, if it exists
            const i9FormDoc = data.documents.find(
              (doc) => doc.documentName === 'I-9 Form'
            )
            // Filter out the I-9 Form from the list to display
            const otherDocs =
              data.documents?.filter(
                (doc) => doc.documentName !== 'I-9 Form'
              ) || []

            return otherDocs.length > 0 ? (
              <>
                {otherDocs.map((doc) => (
                  <Box key={doc.documentUrl} width="100%" mb={3}>
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      mb={2}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleDoc(doc.documentUrl)}
                    >
                      <Box fontWeight="bold">
                        {doc.documentName}{' '}
                        <Icon
                          icon={
                            expandedDocs[doc.documentUrl]
                              ? ChevronDownIcon
                              : ChevronRightIcon
                          }
                        />
                      </Box>
                    </Flex>
                    {expandedDocs[doc.documentUrl] ? (
                      <object
                        data={doc.documentUrl}
                        type="application/pdf"
                        width="100%"
                        height="500px"
                      >
                        <a
                          href={doc.documentUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download PDF
                        </a>
                      </object>
                    ) : null}
                  </Box>
                ))}
                <Box mt={3}>
                  <Flex
                    alignItems="center"
                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                    onClick={(e) => {
                      e.preventDefault()
                      setShowI9Form((v) => !v)
                    }}
                  >
                    <Icon icon={FileTextIcon} />
                    &nbsp;I-9 Form
                    <Box ml={1}>
                      <Icon
                        icon={showI9Form ? ChevronDownIcon : ChevronRightIcon}
                      />
                    </Box>
                  </Flex>
                  {showI9Form ? (
                    <Box mt={2}>
                      <object
                        data={i9FormDoc!.documentUrl}
                        type="application/pdf"
                        width="100%"
                        height="500px"
                      >
                        <a
                          href={i9FormDoc!.documentUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download PDF
                        </a>
                      </object>
                    </Box>
                  ) : null}
                </Box>
              </>
            ) : (
              <Box>
                <Flex
                  alignItems="center"
                  style={{ cursor: 'pointer', display: 'inline-flex' }}
                  onClick={(e) => {
                    e.preventDefault()
                    setShowI9Form((v) => !v)
                  }}
                >
                  <Icon icon={FileTextIcon} />
                  &nbsp;I-9 Form
                  <Box ml={1}>
                    <Icon
                      icon={showI9Form ? ChevronDownIcon : ChevronRightIcon}
                    />
                  </Box>
                </Flex>
                {showI9Form ? (
                  <Box mt={2}>
                    <object
                      data={i9FormDoc!.documentUrl}
                      type="application/pdf"
                      width="100%"
                      height="500px"
                    >
                      <a
                        href={i9FormDoc!.documentUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download PDF
                      </a>
                    </object>
                  </Box>
                ) : null}
              </Box>
            )
          })()}
        </Box>
        {showProcessForm ? <ProcessForm user={user} data={data} /> : null}
      </Card>
    )
  )
}

const Label = styled(Box).attrs({
  fontWeight: 'bold',
  width: 120,
})``
